import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { getEmpresa } from '../../../services/empresaService';
import { headerEmpresa } from '../../helpers/headerEmpresa';

 async function FichaTecnicaPDF(data){

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const empresa = await getEmpresa();
  
  

  const docDefinition = {
    
    pageSize: 'A4',
    pageMargins: [15, 60, 15, 40], // espaço pro header
    header: headerEmpresa(empresa),
    content: [

      { text: 'Ficha Técnica Individualizada', style: 'tituloCentral' },

      {
        columns: [
          { text: `Produto Final: ${data.descricao}` },
          { text: `Qtd Produção: ${data.qtd_resultado} Und`, alignment: 'right' }
        ],
        margin: [0, 5, 0, 5]
      },

      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 }] },

      // ===== CUSTOS =====
      {
        columns: [
          [
            { text: `Custo de Produção: R$ ${(data.compra) * (data.qtd_resultado).toFixed(2)}` },
            { text: `Markup Desejado: ${data.markup.toFixed(2)}%` },
            { text: `Markup Realizado: ${data.lucro.toFixed(2)}%` } 
          ],
          [
            { text: `Custo Unitário: R$ ${data.compra.toFixed(2)}`, alignment: 'right' },
            { text: `Venda Desejada: R$ ${((data.compra * data.markup) / 100 + data.compra).toFixed(2)}`, alignment: 'right' },
            { text: `Venda Atual: R$ ${data.venda.toFixed(2)}`, alignment: 'right' }
          ]
        ],
        margin: [0, 10, 0, 10]
      },

      // ===== ITENS PRODUÇÃO =====
      { text: 'Itens da Produção', style: 'subheader' },

      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 }] },

      {
        table: {
          widths: ['auto', '*', 'auto', 'auto', 'auto'],
          body: [
            [
              { text: 'Código', bold: true },
              { text: 'Descrição', bold: true },
              { text: 'Qtd', bold: true },
              { text: 'Compra', bold: true },
              { text: 'Custo', bold: true }
            ],

            ...data.componentes.map(comp => [
              comp.CODIGO,
              comp.DESCRICAO,
              { text: comp.QUANTIDADE, alignment: 'right' },
              { text: `R$ ${comp.COMPRACOMPONENTE.toFixed(2)}`, alignment: 'right' },
              { text: `R$ ${comp.CUSTOCOMPONENTE.toFixed(2)}`, alignment: 'right' }
            ])
          ]
        },
        layout: 'lightHorizontalLines',
        margin: [0, 5, 0, 15]
      },

      // ===== MODO DE PREPARO =====
      { text: 'Modo de Preparo', style: 'subheader' },

      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 }] },

      {
        text: data.modo.toUpperCase(),
        margin: [0, 5, 0, 0]
      }

    ],

    styles: {
      tituloCentral: {
        fontSize: 12,
        bold: true,
        alignment: 'center',
        margin: [0, 10, 0, 5]
      },
      subheader: {
        bold: true,
        alignment: 'center',
        margin: [0, 10, 0, 5]
      }
    },

    defaultStyle: {
      fontSize: 9
    }
  };

  pdfMake.createPdf(docDefinition).open();
}

export default FichaTecnicaPDF;